import React from 'react';

type SvgProps = {
    color: string;
    size?: number;
};

const Datenschutz: React.FC<SvgProps> = ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.7207 10.23C6.7207 9.78539 6.98253 9.38251 7.3888 9.20194L19.7638 3.70194C20.0547 3.57266 20.3867 3.57266 20.6776 3.70194L33.0526 9.20194C33.4589 9.38251 33.7207 9.78539 33.7207 10.23V18.4989C33.7207 26.728 28.0926 34.4295 20.4873 36.4312C20.3128 36.4772 20.1286 36.4772 19.9541 36.4312C12.3488 34.4295 6.7207 26.728 6.7207 18.4989V10.23ZM16.823 27.1012C17.0426 27.3209 17.3988 27.3209 17.6185 27.1012L28.8244 15.8953C29.0435 15.6762 29.0441 15.3211 28.8258 15.1012L27.5034 13.7696C27.284 13.5486 26.9268 13.5479 26.7065 13.7681L17.6177 22.857C17.3983 23.0764 17.0428 23.0767 16.823 22.8578L13.7334 19.7802C13.5137 19.5613 13.1581 19.5616 12.9387 19.781L11.6185 21.1012C11.3988 21.3209 11.3988 21.6771 11.6185 21.8967L16.823 27.1012Z" fill={color} />
    </svg>


);

export default Datenschutz;
